import * as mutationTypes from './mutation-types'
import {SET_USER_STATUS_SYNC_URL} from "vuejs-user/Login/store/mutation-types";

export default {
    [mutationTypes.SET_AUTHENTICATED] (state, authenticated) {
        state.authenticated = authenticated
    },
    [mutationTypes.SET_KAS_CONFIGURATION_SETTINGS] (state, kasConfigurationSettings) {
        state.kasConfigurationSettings = kasConfigurationSettings
    },
    [mutationTypes.SET_LOGIN_CONTEXT] (state, loginContext) {
        state.loginContext = loginContext
    },
    [mutationTypes.SET_LOGIN_FORM_URL] (state, loginFormUrl) {
        state.loginFormUrl = loginFormUrl
    },
    [mutationTypes.SET_LOGIN_SYNC_URL] (state, loginSyncUrl) {
        state.loginSyncUrl = loginSyncUrl
    },
    [mutationTypes.SET_LOGOUT_SYNC_URL] (state, logoutSyncUrl) {
        state.logoutSyncUrl = logoutSyncUrl
    },
    [mutationTypes.SET_REFRESH_SYNC_URL] (state, refreshSyncUrl) {
        state.refreshSyncUrl = refreshSyncUrl
    },
    [mutationTypes.SET_SHOW_ACCOUNT_NAV] (state, showAccountNav) {
        state.showAccountNav = showAccountNav
    },
    [mutationTypes.SET_UNREGISTER_SYNC_URL] (state, unregisterSyncUrl) {
        state.unregisterSyncUrl = unregisterSyncUrl
    },
    [mutationTypes.SET_USER_INFOS] (state, userInfos) {
        state.userInfos = userInfos
    },
    [mutationTypes.SET_USER_STATUS_SYNC_URL] (state, userStatusSyncUrl) {
        state.userStatusSyncUrl = userStatusSyncUrl
    },
    [mutationTypes.SET_USER_TOKEN] (state, userToken) {
        state.userToken = userToken
    }
}
